import { getHunters } from '@/api/hunters'

const state = {
  list: []
}

const getters = {
  //
}

const mutations = {
  SET_HUNTERS(state: any, data: any) {
    state.list.splice(0, state.list.length)
    data.forEach((hunter: any) => {
      state.list.push(hunter)
    })
  }
}

const actions = {
  async getHunters({ commit }: any) {
    const { data } = await getHunters()
    commit('SET_HUNTERS', data.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
